<main id="main-content" tabindex="-1" class="block bg-white text-[#14213b]">
  <div
    class="mx-auto max-w-screen-2xl px-5 py-8 sm:px-6 lg:px-10 lg:py-16 xl:pb-6"
  >
    <section
      class="relative isolate z-0 mb-14 grid items-center gap-9 lg:mb-[72px] lg:grid-cols-[minmax(0,1fr)_minmax(0,1.25fr)] lg:gap-[52px]"
      aria-labelledby="hero-title"
    >
      <div
        aria-hidden="true"
        class="hero-background absolute -inset-x-[calc((100vw-100%)/2)] -bottom-4 -top-8 -z-10 border-y-4 border-black sm:-bottom-6 sm:-top-10 lg:-top-16"
      ></div>
      <span
        aria-hidden="true"
        class="halftone top-right pointer-events-none absolute -right-5 -top-6 z-0 h-[38%] w-[48vw] sm:-top-10 sm:right-[calc((100vw-100%)/-2)] sm:h-[52%] sm:w-[min(32vw,420px)]"
      ></span>
      <span
        aria-hidden="true"
        class="halftone bottom-left pointer-events-none absolute -bottom-4 -left-5 z-0 h-[38%] w-[48vw] sm:-bottom-6 sm:left-[calc((100vw-100%)/-2)] sm:h-[52%] sm:w-[min(32vw,420px)]"
      ></span>
      <div class="relative z-10 max-w-2xl">
        <p class="font-semibold tracking-widest text-purple-50 mb-6">
          LEARN. CREATE. SHARE. GROW.
        </p>
        <h1 id="hero-title" class="text-container">
          <span class="text-white font-semibold text-4xl block mb-2"
            >Learning makes more sense</span
          >
          <span
            class="text text-flat font-bangers text-8xl pr-2 bg-gradient-to-r from-red-500 via-red-700 to-red-400"
            >when it speaks<br />to you</span
          >
        </h1>

        <!-- <h1
          id="hero-title"
          class="font-semibold tracking-tight select-none my-6 text-[clamp(36px,6.4vw,58px)] leading-[1.02] text-white lg:text-[clamp(36px,3.65vw,58px)]"
        >
          Learning makes more sense<br /><em
            class="not-italic bg-gradient-to-r from-yellow-400 to-yellow-300 bg-clip-text text-transparent"
            >when it speaks to you.</em
          >
        </h1> -->
        <p
          class="max-w-[560px] text-white/85 sm:text-small lg:max-w-[470px] text-2xl md:text-xl leading-relaxed text-blue-50"
        >
          The community where local talent shape relevant, accessible learning.
          Find your "AHA!" moment with resources shared by teachers and students
          just like you.
        </p>
        <div class="my-7 flex flex-wrap items-center gap-4 lg:gap-6">
          <a
            routerLink="/search"
            class="group inline-flex items-center gap-2 rounded-lg bg-red-600 px-4 py-2.5 text-sm font-medium text-white transition-colors duration-200 hover:bg-red-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white"
          >
            <svg
              class="h-4 w-4 transition-transform duration-200 group-hover:scale-110 group-hover:-rotate-6 motion-reduce:transition-none"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.4"
              aria-hidden="true"
            >
              <circle cx="10.5" cy="10.5" r="6.5" />
              <path d="m16 16 5 5" />
            </svg>
            Explore resources</a
          ><a
            routerLink="/get-involved"
            class="inline-flex items-center rounded-lg border border-white px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white"
            >Join the community</a
          >
        </div>
        <div
          class="flex flex-wrap gap-x-5 gap-y-3 text-sm font-normal text-white"
        >
          <span class="inline-flex items-center gap-2">Free to explore</span
          ><span class="inline-flex items-center gap-2"
            >Created by real people</span
          ><span class="inline-flex items-center gap-2">Made for learning</span>
        </div>
      </div>
      <div class="relative z-10 min-w-0 w-full lg:max-w-none">
        @defer (on viewport) {
          <app-featured-resources />
        } @placeholder {
          <section
            class="feature background-purple-blue rounded-3xl border-8 border-white p-5 text-white shadow-xl sm:p-6"
            aria-label="Featured learning resources"
            aria-busy="true"
          >
            <div
              class="feature-top mb-6 flex flex-wrap items-center justify-between gap-x-4 gap-y-2"
            >
              <span
                class="flex items-center gap-2 text-xs font-medium tracking-wider"
                ><i
                  class="h-2 w-2 shrink-0 rounded-full bg-emerald-200"
                  aria-hidden="true"
                ></i>
                THE LEARNING SPOTLIGHT</span
              >
              <a
                routerLink="/shelves"
                class="whitespace-nowrap text-sm font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-200"
                >View shelves <span aria-hidden="true">↗</span></a
              >
            </div>
            <div
              class="feature-body grid min-h-[340px] grid-cols-1 gap-4 sm:grid-cols-[minmax(145px,0.8fr)_minmax(0,1fr)] sm:gap-5"
            >
              <aside class="feature-info flex min-w-0 flex-col sm:pt-3">
                <span class="eyebrow text-sm font-medium leading-relaxed"
                  >A little curiosity. A big discovery.</span
                >
                <h2
                  class="my-2 break-words text-2xl font-semibold leading-snug tracking-tight sm:mb-3 sm:mt-4"
                >
                  Your next lightbulb moment.
                </h2>
                <p
                  class="hidden text-sm font-normal leading-relaxed sm:line-clamp-5"
                >
                  Discover lessons and resources shared by our learning
                  community. Find a new way to understand something.
                </p>
                <div
                  class="feature-pagination mt-auto flex items-center justify-between pt-3 text-sm sm:pt-6"
                >
                  <span>— <span class="muted text-white/80">/ —</span></span>
                  <div class="flex gap-2">
                    <button
                      type="button"
                      disabled
                      class="h-11 w-11 rounded-lg border border-white bg-[#14213b]/50 text-lg hover:enabled:bg-[#14213b] disabled:cursor-default disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-200"
                      aria-label="Previous featured resource"
                    >
                      ←
                    </button>
                    <button
                      type="button"
                      disabled
                      class="h-11 w-11 rounded-lg border border-white bg-[#14213b]/50 text-lg hover:enabled:bg-[#14213b] disabled:cursor-default disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-200"
                      aria-label="Next featured resource"
                    >
                      →
                    </button>
                  </div>
                </div>
              </aside>
              <div
                class="lesson-stage flex min-h-[300px] min-w-0 items-center justify-center overflow-hidden rounded-2xl bg-[radial-gradient(ellipse_at_50%_25%,#6753b3,#244d93_85%)] ring-1 ring-inset ring-white/20 sm:min-h-[340px]"
              >
                <div
                  class="stage-content flex w-full flex-col items-center gap-4 px-5 py-7 text-center"
                >
                  <span
                    class="stage-symbol mb-2 mt-1 h-14 w-14 text-emerald-200"
                    aria-hidden="true"
                  >
                    <svg
                      viewBox="0 0 48 48"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                    >
                      <path
                        d="M18 33h12M19 38h10M22 42h4M17 28c-3-2-5-6-5-10a12 12 0 0 1 24 0c0 4-2 8-5 10l-1 5H18zM24 1v-1M5 18H1m46 0h-4M9 5l3 3m24 0 3-3"
                      />
                    </svg>
                  </span>
                  <p class="text-sm font-normal leading-relaxed" role="status">
                    Finding something worth exploring…
                  </p>
                </div>
              </div>
            </div>
          </section>
        } @error {
          <div
            class="flex min-h-[510px] flex-col justify-center gap-5 rounded-[22px] bg-[#111b31] p-9 text-white sm:min-h-[428px]"
          >
            <h2>Keep exploring.</h2>
            <a
              routerLink="/search"
              class="text-sm text-[#c7d6ec] underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-3 focus-visible:outline-offset-[5px] focus-visible:outline-blue-300"
              >Browse free resources →</a
            >
          </div>
        }
        <p
          class="mt-4 text-center text-sm font-normal leading-relaxed text-white/90"
        >
          <span aria-hidden="true" class="mr-[5px] text-[#78dcff]">✦</span> A
          fresh perspective can make all the difference.
        </p>
      </div>
    </section>
    <app-explore-subjects />
  </div>
  <div class="comic-book flex flex-col bg-white py-12">
    <section
      id="community-section"
      class="rotate flex flex-wrap min-h-[66vh] background-purple-blue relative border-4 border-black"
      aria-labelledby="community-title"
    >
      <span
        aria-hidden="true"
        class="absolute w-1/3 right-0 top-0 h-full halftone top-right"
      ></span>
      <span
        aria-hidden="true"
        class="absolute w-1/3 left-0 bottom-0 h-full halftone bottom-left ht-dark"
      ></span>
      <div class="straighten w-full lg:w-1/2 p-8 flex items-center">
        <div class="p-2 md:p-8">
          <p class="font-semibold tracking-widest text-purple-50 mb-6">
            LOCAL VOICES. SHARED POSSIBILITIES.
          </p>
          <h2 id="community-title" class="text-container">
            <span
              class="text text-flat font-bangers text-6xl md:text-8xl pr-2 bg-gradient-to-r from-orange-500 to-yellow-300"
              >Learning makes more sense</span
            >
          </h2>
          <h3
            class="text-4xl md:text-6xl font-semibold tracking-tight mt-4 text-purple-50"
          >
            when it speaks to you.
          </h3>
        </div>
      </div>
      <div class="straighten w-full lg:w-1/2 p-8 flex items-center">
        <div class="p-2 md:p-8">
          <p class="text-2xl md:text-3xl leading-relaxed text-purple-50">
            Study Heroes is a community where local talent helps shape relevant,
            accessible learning. We put education, educators and students first
            — with no sign-in needed to start exploring.
          </p>
          <div class="mt-10">
            <a
              routerLink="/mother-tongue-education-benefits"
              class="btn-comic-outline inline-block bg-orange-600 hover:bg-orange-500"
              >Discover our mother tongue initiative
              <span aria-hidden="true">→</span></a
            >
          </div>
        </div>
      </div>
    </section>
    @defer (on viewport) {
      <!-- Section 1/1 -->
      <div
        id="education-first-section"
        class="rotate flex flex-wrap min-h-[66vh] background-green relative border-4 border-black mt-2"
      >
        <span
          class="absolute w-1/4 right-0 top-0 h-full halftone top-right"
        ></span>

        <span
          class="absolute w-1/4 left-0 bottom-0 h-full halftone bottom-left ht-dark"
        ></span>

        <div class="straighten w-full hidden md:w-1/2 p-8 md:flex items-center">
          <div class="p-8 flex flex-col justify-center">
            <h2 class="text-container">
              <span
                class="text text-flat font-bangers text-6xl md:text-8xl pr-2 bg-gradient-to-r from-purple-950 via-purple-700 to-purple-900"
                >Education first</span
              >
            </h2>
            <h3
              class="text-4xl md:text-6xl font-semibold tracking-tight select-none mb-2 text-purple-50"
            >
              It's that simple.
            </h3>

            <p class="mt-6 text-2xl md:3xl text-purple-50">
              Study Heroes puts education, educators and students first. Instant
              access to quality education, no sign in, no pay wall.
            </p>

            <div class="mt-10">
              <a
                href="/get-involved"
                class="btn-comic-outline bg-purple-700 hover:bg-purple-500"
                >Get Involved</a
              >
              <button
                (click)="scrollToElement('curated-section')"
                class="ml-4 text-xl font-semibold leading-6 text-white"
              >
                Learn more <span aria-hidden="true">→</span>
              </button>
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/2 p-4 flex items-end justify-center">
          <div class="p-4 rotate-[8deg]">
            <div class="mockup-phone border-violet-800">
              <div class="camera"></div>
              <div class="display">
                <div
                  class="artboard artboard-demo phone-1 background-blue relative"
                >
                  <span
                    class="absolute w-2/4 right-0 top-0 h-full halftone top-right"
                  ></span>

                  <span
                    class="absolute w-2/4 left-0 bottom-0 h-full halftone bottom-left ht-dark"
                  ></span>
                  <img
                    src="/assets/images/backgrounds/bg_fade_pink.svg"
                    class="absolute top-0 opacity-50"
                  />
                  <img
                    src="/assets/images/logo-v-h.svg"
                    alt="Study Heroes app screenshot"
                    class="py-3 w-48 z-20"
                  />
                  <div class="p-2 z-10">
                    <h2 class="text-container">
                      <span
                        class="text text-flat font-bangers text-4xl md:text-5xl pr-1 bg-gradient-to-r from-purple-950 via-purple-700 to-purple-900"
                        >Education first</span
                      >
                    </h2>
                    <h3
                      class="text-3xl font-semibold tracking-tight select-none mb-1 text-purple-50"
                    >
                      It's that simple.
                    </h3>
                    <p class="mt-3 text-lg text-purple-50">
                      Study Heroes puts education, educators and students first.
                      Instant access to quality education, no sign in, no pay
                      wall.
                    </p>
                    <div class="mt-4 flex items-center">
                      <a
                        href="/get-involved"
                        class="btn-comic-outline bg-purple-700 hover:bg-purple-500 text-sm px-2 py-1"
                        >Get Involved</a
                      >
                      <button
                        (click)="scrollToElement('curated-section')"
                        class="ml-2 text-sm font-semibold leading-6 text-white"
                      >
                        Learn more <span aria-hidden="true">→</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    } @placeholder {
      <div
        id="education-first-section"
        class="rotate flex flex-wrap min-h-[66vh] background-green relative border-4 border-black mt-2"
      ></div>
    }

    @defer (on viewport) {
      <!-- Section 1/1 -->
      <div
        id="curated-section"
        class="rotate flex flex-wrap min-h-screen background-pink relative border-4 border-black"
      >
        <span class="absolute w-full right-0 h-full halftone top-right"></span>
        <!--
    <img
      src="assets/images/trinkets/Protractor1.svg"
      alt="Protractor"
      class="absolute top-0 left-0 w-full h-full object-contain opacity-50 pointer-events-none"
    /> -->

        <div class="straighten w-full lg:w-1/2 p-8 flex items-center">
          <div class=".panel-container">
            <h2 class="text-container">
              <span
                class="text text-flat font-bangers text-6xl md:text-8xl pr-2 bg-gradient-to-r from-green-600 to-green-400"
                >Curated Content</span
              >
            </h2>
            <h3
              class="text-4xl md:text-4xl md:text-6xl font-semibold tracking-tight select-none mb-2 text-green-50"
            >
              By teachers and students just like you.
            </h3>
            <p class="mt-6 text-2xl md:3xl text-green-50 opacity-95 leading-8">
              Save countless hours of prep work by using resources curated and
              linked by teachers for books you are already using to assist with
              your lesson plans.
            </p>
            <div
              class="mt-10 flex flex-col space-y-4 md:flex-row md:space-y-0 md:space-x-4 w-fit self-start"
            >
              <a
                href="/get-involved"
                class="btn-comic-outline bg-green-700 hover:bg-green-600"
                >Get Involved</a
              >
              <button
                (click)="scrollToElement('creator-tools-section')"
                class="text-xl font-semibold leading-6 text-white"
              >
                Learn more <span aria-hidden="true">→</span>
              </button>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2 p-4 flex items-center justify-center">
          <div class="p-4">
            <div
              class="mockup-phone border-lime-400 drop-shadow-[10px_10px_4px_rgba(0,0,0,0.33)] transform rotate-90"
            >
              <div class="camera"></div>
              <div class="display">
                <div class="artboard artboard-demo phone-1 bg-black">
                  <div
                    class="transform -rotate-90 w-full h-full flex items-center justify-center"
                  >
                    <iframe
                      loading="lazy"
                      width="596"
                      height="348"
                      src="https://www.youtube.com/embed/FSyc0QaChGM?si=2EvRVfd8KjFNN2Es&amp;controls=1&amp;rel=0&amp;vq=hd720"
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    } @placeholder {
      <div
        id="curated-section"
        class="rotate flex flex-wrap min-h-screen background-pink relative border-4 border-black"
      ></div>
    }

    @defer (on viewport) {
      <div
        id="creator-tools-section"
        class="rotate flex flex-wrap min-h-screen background-blue relative border-4 border-black"
      >
        <span
          class="absolute w-1/3 left-0 h-full halftone bottom-0 bottom-left"
        ></span>
        <span
          class="absolute w-1/3 right-0 top-0 h-full halftone top-right"
        ></span>

        <div class="straighten w-full lg:w-1/2 p-8 flex items-center">
          <div class=".panel-container">
            <h2 class="text-container">
              <span
                class="text text-flat font-bangers text-6xl md:text-8xl pr-2 bg-gradient-to-r from-red-700 to-orange-400"
                >Creator Tools</span
              >
            </h2>
            <h3
              class="text-4xl md:text-6xl font-semibold tracking-tight select-none mb-2 text-blue-50"
            >
              All in one teaching eco system.
            </h3>
            <p class="mt-6 text-2xl md:3xl text-blue-50">
              We are crafting a dedicated all in one teaching platform, so that
              content creators and teachers can create and publish resources
              directly from Study Heroes. Reducing the cost and complication of
              creating and publishing quality content to students and teachers
              across the globe.
            </p>
            <div
              class="mt-10 flex flex-col space-y-4 md:flex-row md:space-y-0 md:space-x-4 w-fit self-start"
            >
              <a
                href="/get-involved"
                class="btn-comic-outline bg-orange-500 hover:bg-orange-600"
                >Get Involved</a
              >
              <button
                (click)="scrollToElement('roadmap-section')"
                class="ml-4 text-xl font-semibold leading-6 text-white"
              >
                Learn more <span aria-hidden="true">→</span>
              </button>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2 p-4 flex items-center justify-center">
          <div class="p-4 straighten">
            <!-- ADD THE VIDEO OF ME CHANGING CONTENT INTO ANOTHER LANGUAGE IN MINUTES -->

            @if (demoResource) {
              <app-view-content
                [selectedFileUrl]="
                  'https://cdn.studyheroes.app/58467c74-226e-45ec-9673-fd37a289861c/2024/10/24/simple_electric_circuit.riv'
                "
                [fileType]="'rive'"
                [selectedResource]="demoResource"
                [recordControls]="true"
              ></app-view-content>
            } @else {
              <div class="p-8 text-center text-white">
                @if (demoLoading) {
                  <p role="status">Loading the creator demo…</p>
                } @else {
                  @if (demoError) {
                    <p role="alert" class="mb-4">{{ demoError }}</p>
                  }
                  <button
                    type="button"
                    class="btn-comic-outline bg-orange-600 hover:bg-orange-500"
                    (click)="loadDemo()"
                  >
                    {{ demoError ? 'Try again' : 'Try the creator demo' }}
                  </button>
                }
              </div>
            }
          </div>
        </div>
      </div>
    } @placeholder {
      <div
        id="creator-tools-section"
        class="rotate flex flex-wrap min-h-screen background-blue relative border-4 border-black"
      ></div>
    }

    @defer (on viewport) {
      <div
        id="roadmap-section"
        class="rotate flex flex-wrap min-h-screen background-deep-purple-pink relative border-4 border-black"
      >
        <span class="absolute w-1/3 left-0 h-full halftone bottom-left"></span>
        <span
          class="absolute w-1/3 right-0 top-0 h-full halftone top-right"
        ></span>

        <div class="absolute right-8 -bottom-4 md:right-8 z-20">
          <a
            href="/get-involved"
            class="border-black border-4 to-purple-800 from-purple-700 read-more bg-gradient-to-r transition-all duration-300 ease-in-out hover:bg-gradient-to-r hover:from-purple-600 hover:to-purple-700"
          >
            <span
              class="font-bangers text-4xl md:text-6xl pr-2 text-white"
              data-text="Study Heroes puts Education, Teachers and Students first."
              >Get Involved</span
            >
          </a>
        </div>

        <div class="straighten w-full p-8 flex items-center">
          <div class=".panel-container">
            <h2 class="text-container">
              <span
                class="text text-flat font-bangers text-6xl md:text-8xl pr-2 bg-gradient-to-r from-purple-700 to-pink-400"
                >Road Map</span
              >
            </h2>
            <h3
              class="text-4xl md:text-6xl font-semibold tracking-tight select-none mb-2 text-pink-50"
            >
              Innovative features for teachers, students and content creators.
            </h3>
            <p class="mt-6 pb-16 text-3xl text-pink-50">
              Our team continues to work closely with the community to deliver
              engaging features, content and updates inspired by feedback.
            </p>
            <div class="mt-10 hidden md:block">
              <a
                href="/get-involved"
                class="btn-comic-outline bg-pink-500 hover:bg-pink-600"
                >Get Involved</a
              >
            </div>
          </div>
        </div>
      </div>
    } @placeholder {
      <div
        id="roadmap-section"
        class="rotate flex flex-wrap min-h-screen background-deep-purple-pink relative border-4 border-black"
      ></div>
    }
  </div>
</main>
